import type {
  ThemeId,
} from '../theme/themes'

export type PanelSide =
  | 'LEFT'
  | 'RIGHT'

export interface PanelLayout {
  id: string
  side: PanelSide
  order: number
  visible: boolean
}

export interface GenesisPreferences {
  theme: ThemeId

  fontFamily: string
  textColor: string

  backgroundBaseColor: string
  backgroundIntensity: number
  backgroundContrast: number

  designLocked: boolean

  clock24Hour: boolean
  showDate: boolean

  moduleBackgroundColor: string
  conversationBackgroundColor: string
  clockColor: string
  topButtonBackgroundColor: string
  topButtonTextColor: string

  systemButtonColumns:
    1 | 2 | 3

  layoutPreset:
    | 'GENESIS'
    | 'COMMAND'
    | 'STUDIO'
    | 'LIGHT_PRO'

  generalScale: number
  buttonScale: number
  buttonPhysicalScale: number

  systemButtonTextScale: number
  engineeringTextScale: number

  clockTimeScale: number
  clockDateScale: number

  clockTimeColor: string
  clockDateColor: string

  descriptionScale: number

  density: number
  radius: number

  designMode: boolean

  leftWidth: number
  rightWidth: number

  panels: PanelLayout[]

  panelHeights:
    Record<string, number>
}

export const DEFAULT_PREFERENCES:
GenesisPreferences = {
  theme: 'GENESIS',

  fontFamily:
    'Inter, ui-sans-serif, system-ui, "Segoe UI", sans-serif',

  textColor: '#e4edf5',

  backgroundBaseColor: '#06111a',
  backgroundIntensity: 100,
  backgroundContrast: 55,

  designLocked: true,

  clock24Hour: false,
  showDate: true,

  moduleBackgroundColor: '#071622',
  conversationBackgroundColor: '#071622',
  clockColor: '#64dbe0',
  topButtonBackgroundColor: '#091b26',
  topButtonTextColor: '#e4edf5',

  systemButtonColumns: 2,

  layoutPreset: 'GENESIS',

  generalScale: 1,
  buttonScale: 1,
  buttonPhysicalScale: 1,

  systemButtonTextScale: 1,
  engineeringTextScale: 1,

  clockTimeScale: 1,
  clockDateScale: 1,

  clockTimeColor: '#64dbe0',
  clockDateColor: '#7893a2',

  descriptionScale: 1,

  density: 1,
  radius: 15,

  designMode: false,

  leftWidth: 255,
  rightWidth: 285,

  panels: [],

  panelHeights: {},
}

const KEY =
  'sei-genesis-layout-v3-r7'

export function loadPreferences():
GenesisPreferences {
  try {
    const raw =
      localStorage.getItem(KEY)

    if (!raw) {
      return structuredClone(
        DEFAULT_PREFERENCES,
      )
    }

    const saved =
      JSON.parse(raw)

    return {
      ...structuredClone(
        DEFAULT_PREFERENCES,
      ),
      ...saved,
    }
  } catch {
    return structuredClone(
      DEFAULT_PREFERENCES,
    )
  }
}

export function savePreferences(
  preferences:
    GenesisPreferences,
) {
  localStorage.setItem(
    KEY,
    JSON.stringify(
      preferences,
    ),
  )
}

export function resetPreferences() {
  localStorage.removeItem(KEY)

  return structuredClone(
    DEFAULT_PREFERENCES,
  )
}
